export default "__VITE_ASSET__CyY$W7gS__"